import { Box, Typography } from '@mui/material'

/**
 * Where Composio returns the browser after hosted OAuth.
 *
 * Deliberately inert. It reads nothing from the URL and reports no outcome:
 * the tab that started the flow is polling the provider, and that poll is the
 * only thing that establishes whether a connection exists. Treating the query
 * parameters here as proof would let anyone who can craft a URL appear
 * connected.
 */
export default function IntegrationsCallbackPage() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        minHeight: '100vh',
        px: 3,
        textAlign: 'center',
      }}
    >
      <Typography variant="h6">You can close this tab</Typography>
      <Typography variant="body2" color="text.secondary">
        Finishing up in DO Sense — head back to the tab you started from.
      </Typography>
    </Box>
  )
}
